var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingCall1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4297 0C14.8598 0 16 0.872922 16 3.5V10.5C16 13.1271 14.849 14 11.4297 14H4.57031C1.14019 14 3.92068e-07 12.2542 0 10.5V3.5C0 0.872922 1.14019 0 4.57031 0H11.4297ZM11.5 3C10.6716 3 10 3.67157 10 4.5C10 5.32843 10.6716 6 11.5 6C12.3284 6 13 5.32843 13 4.5C13 3.67157 12.3284 3 11.5 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8926 11.5836L16.25 9.83155V4.1622L18.8926 2.41019C20.1854 1.55664 21.25 2.07775 21.25 3.5782V10.4245C21.25 11.925 20.1854 12.4461 18.8926 11.5836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCall1);
export default __webpack_public_path__ + "static/media/floating-call-1.24e99bd5be8573a45adcce9232d5e911.svg";
export { ForwardRef as ReactComponent };